import styled from '@emotion/styled'

export const Container = styled.span`
  color: ${(props) => props.theme.palette.error.main};
  font-size: 14px;
`
